(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const revealItems = document.querySelectorAll('[data-crystal-reveal]');

  if (revealItems.length) {
    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealItems.forEach((item) => item.classList.add('is-visible'));
    } else {
      document.documentElement.classList.add('crystal-reveal-ready');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.14 });
      revealItems.forEach((item) => observer.observe(item));
    }
  }

  document.querySelectorAll('[data-crystal-tabs]').forEach((tabs) => {
    const buttons = Array.from(tabs.querySelectorAll('[data-crystal-tab]'));
    const panels = Array.from(tabs.querySelectorAll('[data-crystal-panel]'));
    if (!buttons.length || !panels.length) return;

    tabs.classList.add('crystal-tabs-ready');

    const activate = (name) => {
      buttons.forEach((button) => {
        const selected = button.dataset.crystalTab === name;
        button.setAttribute('aria-selected', selected ? 'true' : 'false');
        button.tabIndex = selected ? 0 : -1;
      });
      panels.forEach((panel) => {
        const selected = panel.dataset.crystalPanel === name;
        panel.classList.toggle('is-active', selected);
        panel.hidden = !selected;
      });
    };

    buttons.forEach((button, index) => {
      button.addEventListener('click', () => activate(button.dataset.crystalTab));
      button.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const nextIndex = (index + direction + buttons.length) % buttons.length;
        buttons[nextIndex].focus();
        activate(buttons[nextIndex].dataset.crystalTab);
      });
    });

    activate(buttons[0].dataset.crystalTab);
  });
})();
